import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import utils from "../../universal/utils";
import {
  setMatchPageLandedSoundMuted,
} from "../../universal/matchNotificationSounds";

const basePath = utils.getEdgeBasePath();

export default function MatchStartSoundToggle({ user, actions }) {
  const serverMuted = user?.soundPreferences?.matchPageLandedMuted === true;
  const [muted, setMuted] = useState(serverMuted);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setMuted(user?.soundPreferences?.matchPageLandedMuted === true);
  }, [user?.soundPreferences?.matchPageLandedMuted]);

  if (!user?.userId) {
    return null;
  }

  const handleChange = async (event) => {
    const nextMuted = !event.target.checked;
    setMuted(nextMuted);
    setMatchPageLandedSoundMuted(nextMuted);
    setSaving(true);
    setError("");

    try {
      const res = await fetch(`${basePath}/api/v1/account`, {
        method: "POST",
        credentials: "include",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          data: {
            userId: user.userId,
            soundPreferences: { matchPageLandedMuted: nextMuted },
          },
        }),
      });
      const response = await res.json().catch(() => null);
      if (!res.ok || response?.ok === false) {
        throw new Error(
          response?.message || "Failed to update sound preferences"
        );
      }
      if (typeof actions?.refreshSessionUser === "function") {
        await actions.refreshSessionUser();
      }
    } catch (err) {
      setMuted(!nextMuted);
      setMatchPageLandedSoundMuted(!nextMuted);
      setError(
        err?.message || "Failed to update sound preferences. Please try again."
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ mt: 4, mb: 2 }}>
      <Divider sx={{ borderColor: "rgba(255,255,255,0.08)", mb: 3 }} />
      <Typography
        variant="h6"
        sx={{ mb: 1.5, fontWeight: 700, color: "rgba(255,255,255,0.9)" }}
      >
        Sounds
      </Typography>
      <Typography
        variant="body2"
        sx={{ mb: 2, color: "rgba(255,255,255,0.6)", lineHeight: 1.5 }}
      >
        Play a short cue when you land on the match page after a match is found.
      </Typography>
      <FormControlLabel
        control={
          <Switch
            checked={!muted}
            onChange={handleChange}
            disabled={saving}
            name="matchStartSoundEnabled"
          />
        }
        label="Match start sound"
      />
      {error ? (
        <Typography variant="caption" color="error" display="block" sx={{ mt: 1 }}>
          {error}
        </Typography>
      ) : null}
    </Box>
  );
}

MatchStartSoundToggle.propTypes = {
  user: PropTypes.object,
  actions: PropTypes.object,
};
